module.exports = __webpack_public_path__ + "static/dip-video-player-tablet.62938b5a.webp";